<template>
    <el-dialog
      title="修改库存数量"
      :visible.sync="show"
      @close="$emit('input',false)"
      width="50%">
      <!-- <el-input-number v-model="num" :min="0" :max="Infinity" label="描述文字"></el-input-number> -->
      <el-table
        :data="[detail]"
        style="width: 100%"
        :header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
        <el-table-column
          v-for="(item,index) in headerList"
          :key="index"
          :label="item.label"
          :width="item.width" >
          <template slot-scope="scope">
            <div v-if="item.prop=='newkucun'">
              <el-input-number v-model="num" controls-position="right" :min="0" :step-strictly="true"></el-input-number>
            </div>
            <div v-else-if="item.prop=='stock_num'">
              {{ scope.row[item.prop] }}
            </div>
            <div v-else>
              {{ scope.row[item.prop] || '--' }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="sureFn">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import { throttle } from 'lodash-unified'
import { mapActions } from 'vuex'
export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      detail: {
        type: Object,
        default: ()=>{}
      }
    },
    watch:{
      value(nval){
        this.show = nval
      },
      detail(nval){
        this.num = nval.stock_num || 0
      }
    },
    data(){
        return {
          show: false,
          num: 1,
          headerList: [
            {
              prop: 'title',
					    label: '课程名称'
            },
            {
              prop: 'sale_price',
					    label: '价格',
            },
            {
              prop: 'stock_num',
					    label: '当前库存',
            },
            {
              prop: 'newkucun',
					    label: '改后库存'
            },
          ]
        }
    },
    methods: {
      ...mapActions('sphApis', ['setStockNumAPI']),
      sureFn:throttle(async function(){
        await this.setStockNumAPI({
          "id": this.detail.id , 
          "stock_num": this.num
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('sureEdit')
        this.$emit('input',false)
      },1000)
    }
}
</script>
